<script>
  import Header from "./header-section.svelte";
  import { design_analysis, design_analysis_mob } from "./header_data.js";
  import Footer from "./footer.svelte";
  // import Button from "./button.svelte";
  import { title, show } from "./store.js";
  import PopUpButton from "./popUp_button.svelte";
  import MobileButton from "./popUp_button_mob.svelte";
  import MobileView from "./design_analysis_mbl.svelte";
  import YourPlan from "./submit_your_plan.svelte";
  title.set("Design & Analysis");
  let foundation_list = [
    { mark: "Building Foundations" },
    { mark: "Equipment Foundations" },
    { mark: "Dynamic/Vibratory Equipment Foundations" },

    { mark: "Deep Foundation Systems" },
    { mark: "Specialty Foundations" },
  ];

  let specialty = [
    {
      mark: "Structural design of Plant and Industrial Equipment",
    },
    {
      mark: "Detailed Civil Design of Plants",
    },
    {
      mark: "Value Engineering",
    },
    {
      mark: "Steel, Fabricatidesign_analysis",
    },
    {
      mark: "Connection Design",
    },
    {
      mark: "Vibration/Dynamic Analysis",
    },
    {
      mark: "PIPE Rack Structures & Piping Support system Design",
    },
    {
      mark: "Miscellaneous Steel (Stairs, Rails, Ladders, Catwalk, Platforms)",
    },
    {
      mark: "Industrial Buildings & Overhead Crane Buildings ",
    },
    {
      mark: "Design of Steel and Concrete Bridges and Culverts",
    },
    {
      mark: "Tanks, Bins, Silos, Chimney Designs",
    },
  ];

  let architectural = [
    { mark: "Landscape Designs." },
    { mark: "Building Façade Improvements and Design" },
    { mark: "Urban Planning, Designs" },
    { mark: "Interior Design" },
    { mark: "Architectural Plans, Layouts and Detailed Design" },
    { mark: "Curtain Wall Design" },
    { mark: "Skylights Design" },
  ];

  let framing = [
    { mark: "Structural Steel industrial buildings, storage sheds " },
    { mark: "Cast in Place Concrete" },
    { mark: "Masonry" },
    { mark: "Pre engineered buildings" },
    { mark: "Precast & Prestressed Concrete" },
    { mark: "Tilt-up Concrete" },
    { mark: "Modular based steel and concrete structures and buildings" },
  ];

  let bridge_list = [
    { mark: "Design of Concrete bridges" },
    { mark: "Box girder bridge" },
    { mark: "Self supported towers" },
    { mark: "Mono pole towers" },
    { mark: "Box culverts " },
    { mark: "Communication Tower Design" },

    { mark: "Guy mast towers" },
    { mark: "Antenna supports" },
    { mark: "Capacity analysis of Existing towers" },
  ];
  let cost = [
    { mark: "Project Management" },
    { mark: "Site Supervision Supervision" },
    { mark: "Time & Cost Management" },
    { mark: "Project Scheduling" },
    { mark: "Tenders /Proposal/BOQ /MTO and All Other Construction Documents" },
  ];

  let infrastructure = [
    { mark: "Road Design" },
    { mark: "Grading and Storm Drainage Design " },
    { mark: "Land development, Grading and Paving Design" },

    {
      mark: "Underground Services, Sanitary Sewer and Water Supply systems Design.",
    },
  ];

  let construction = [
    { mark: "Temporary Bracing" },
    { mark: "Formwork and Scaffolding Design" },
    { mark: "Rigging & Lift Planning" },
    { mark: "Field Modifications" },
    { mark: "Technical site Support to Site Staff" },
  ];

  let modification = [
    { mark: "Expansion Planning" },
    { mark: "Design of Reinforcement" },
    { mark: "Modifications" },
    {
      mark: "Retrofitting Design for Over stressed / Seismically damaged structures. ",
    },
    { mark: "Stability Review of Existing buildings" },
  ];

  function displayPopUp() {
    show.update((n) => n + 1);
    console.log("show", show);
  }
</script>

<Header
  style="background: linear-gradient(253.39deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.53) 99.46%);
"
  data_desktop={design_analysis}
  data_mobile={design_analysis_mob}
  line_stroke={"white"}
  top={"90vw"}
  logo_color={"white"}
  logo_stroke={"white"}
  border_color={"0.234vw solid #FFFFFF "}
  Width_line="39.5vw"
  width_des="66vw"
>
  <div slot="btn">
    <div class="desktop" style="margin-top: 0.5vw; margin-left:7.135vw;">
      <PopUpButton
        border_radius="0.625vw"
        padding="1.042vw 3.073vw"
        title="Contact"
        me="2"
        btnStyle="nav_bar_btn"
        px="0"
        on:click={() => {
          displayPopUp();
        }}
      />
    </div>
    <div class="mobile">
      <MobileButton
        title={"Contact"}
        on:click={() => {
          displayPopUp();
        }}
      />
    </div>
  </div>
</Header>
<YourPlan />
<div class="desktop">
  <div style=" padding: 0vw; marging: 0vw;overflow:hidden; ">
    <div
      style="
      position:absolute;
      height: 7vw;
      width: 66.771vw;
      left: 16.615vw;
      top: 49.792vw;
      
      font-family: 'Poppins';
      font-size: 1.563vw;
      font-weight: 400;
      line-height: 2.344vw;
      text-align: center;
      
      "
    >
      We aim to find the most creative, cost-effective solution to every design
      and to keep projects on budget and on time. As a result, we have clients
      happily return to us with their next projects.
    </div>

    <div style="position: relative; top: 18.08vw; left: 13.885vw;">
      <div style="position:absoulte; width:73vw; height:1.9vw;">
        <img
        src="images/design_analysis/lines.svg"
        alt=""
        width="100%"
      />
      </div>
      <div
        style="position: absolute;
        font-family: Poppins;
        font-size: 2.083vw;
        font-weight: 600;
        line-height: 2.813vw;
        text-align: left;
        text-transform: uppercase;
        left: 1vw;
        top: -1.5vw;">
        When your project is ready for design, we have your solutions:
      </div>
    </div>

    <div
      style="position: relative;top:24.188vw; height: 285.885vw; background:#F9F6EF;"
    >
      <div
        class="sec1"
        style=" position: absolute; width: 82.031vw; height: 26.042vw;"
      >
        <div style=" height:30.042vw; width: 50vw;">
          <img class="side" src="images/design_analysis/design1.svg" alt="" />
          <div class="para" style="width:51.750vw; height: 15.729;">
            <img
              style="top:1.4vw;"
              class="scale"
              src="images/design_analysis/1.svg"
              alt=""
            />
            <heading style="top:1vw;" class="top">Foundation Design :</heading>

            <ul class="list" style=" left: 5vw; top:2vw;">
              {#each foundation_list as high}
                <li class="found">{high.mark}</li>
              {/each}
            </ul>
            <button
              class="submit"
              style="top:2vw; left: 6vw;"
              on:click={() => {
                displayPopUp();
              }}
              >Submit Your Plan <img
                class="arrow"
                src="/images/home_page/arrow.svg"
                alt=""
              /></button
            >
          </div>
        </div>
      </div>

      <div
        class="section2"
        style="position:absolute; top: 33.281vw; width: 90.313vw;height:22.208vw; left: 4.844vw; "
      >
        <img
          style="top:0.5vw;"
          class="scale"
          src="images/design_analysis/2.svg"
          alt=""
        />

        <heading class="top" style="left:3.052vw;"
          >Specialty Engineering & Design :</heading
        >

        <ul class="specialty" style=" left:5.854vw; top:2vw;">
          {#each specialty as spec}
            <li class="sec2" style="">{spec.mark}</li>
          {/each}
        </ul>

        <button
          class="submit"
          style=" left:6.854vw; top:2vw;"
          on:click={() => {
            displayPopUp();
          }}
          >Submit Your Plan <img
            class="arrow"
            src="/images/home_page/arrow.svg"
            alt=""
          /></button
        >
      </div>

      <div class="sec3" style="position:absolute; top:57.521vw; ">
        <img
          class="side"
          style="left:56.302vw; height:26.042vw;width: 36.406vw; "
          src="images/design_analysis/design2.png"
          alt=""
        />
        <div class="para" style="left: 4vw; height:23.438vw;width:50vw;">
          <img
            style="top:0.5vw;"
            class="scale"
            src="images/design_analysis/3.svg"
            alt=""
          />
          <heading style="left:3.5vw" class="top"
            >Architectural Design :</heading
          >

          <ul class="list" style=" left: 7vw; top: 1vw; width:45vw;">
            {#each architectural as arch}
              <li style="width: 15vw;" class="archit">{arch.mark}</li>
            {/each}
          </ul>
          <button
            style="left: 7vw; top: 2vw;"
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
      </div>

      <div class="sec4" style="position:absolute; height:auto; top:92.177vw;">
        <img class="side" src="images/design_analysis/design3.svg" alt="" />
        <div
          class="extra"
          style="position:relative; left:48vw; top:-2vw; width:50vw;"
        >
          <img class="scale" src="images/design_analysis/4.svg" alt="" />
          <heading class="top">MEP design :</heading>

          <ul class="list" style=" left: 5vw;">
            <li class="mep" style=" position:relative; width: 30vw; ">
              We offer Complete Solution in MEP for Plants, Industrial,
              Commercial, Offices, High rise and Multi Story Buildings
            </li>
          </ul>
          <button
            class="submit"
            style=" left:5vw; top: 0vw;"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
        <div class="para" style="top: 11vw; width: 50vw;">
          <img class="scale" src="images/design_analysis/5.svg" alt="" />
          <heading class="top">Design of Building Framing Systems :</heading>
          <ul class="list" style=" left: 5vw; top:1vw;">
            {#each framing as frame}
              <li class="sec3">{frame.mark}</li>
            {/each}
          </ul>
          <button
            style="top:1vw; left: 6vw;"
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
      </div>

      <div style="position:absolute; top: 133vw;">
        <img
          class="side"
          style="left:56.302vw; height:26.042vw;width: 36.406vw; "
          src="images/design_analysis/design4.png"
          alt=""
        />
        <div class="para" style="left: 6vw; top:-2vw; width: 45vw; ">
          <img class="scale" src="images/design_analysis/6.svg" alt="" />
          <heading class="top">Project & Cost Management :</heading>

          <ul class="list" style=" left: 5vw; top:1vw;">
            {#each cost as penny}
              <li style="width: 15vw;" class="sec4">{penny.mark}</li>
            {/each}
          </ul>
          <button
            style="left: 6vw; top:0vw;"
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>

        <div class="para" style="left: 6vw; top:22vw ;width:50vw">
          <img class="scale" src="images/design_analysis/7.svg" alt="" />
          <heading class="top">Infrastructure Design :</heading>

          <ul class="list" style=" left: 5vw;">
            {#each infrastructure as infra}
              <li style="">{infra.mark}</li>
            {/each}
          </ul>
          <button
            style="top: -1vw; left:6vw; "
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
      </div>

      <div style="position:absolute; top:172.5vw;">
        <img class="side" src="images/design_analysis/design5.png" alt="" />

        <div class="para" style="left: 48vw; width:50vw">
          <img class="scale" src="images/design_analysis/8.svg" alt="" />
          <heading class="top">Bridge Engineering :</heading>

          <ul class="list" style=" left: 5vw; top:1vw;">
            {#each bridge_list as brid}
              <li class="sec5">{brid.mark}</li>
            {/each}
          </ul>
          <button
            style="top: 2vw; left:6vw;"
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
      </div>

      <div style="position:absolute; top:206vw">
        <img
          class="side"
          style="left:56.302vw; height:26.042vw;width: 36.406vw; "
          src="images/design_analysis/design6.png"
          alt=""
        />
        <div class="para" style="left: 4vw; width: 50vw">
          <img class="scale" src="images/design_analysis/9.svg" alt="" />
          <heading class="top">Construction Engineering :</heading>

          <ul class="list" style=" left: 5vw; top:1vw;">
            {#each construction as con}
              <li class="archit" style="width: 17vw;">{con.mark}</li>
            {/each}
          </ul>
          <button
            style="left: 6vw; top:2vw;"
            class="submit"
            on:click={() => {
              displayPopUp();
            }}
            >Submit Your Plan <img
              class="arrow"
              src="/images/home_page/arrow.svg"
              alt=""
            /></button
          >
        </div>
      </div>

      <div
        class="last"
        style="position:absolute; top:238vw; left:7.125vw; width:93%;"
      >
        <img
          style=" left: -4vw;"
          class="scale"
          src="images/design_analysis/10.svg"
          alt=""
        />

        <heading class="top" style="left:0vw;"
          >Review & Modification of Existing Structures :</heading
        >

        <ul class="specialty" style=" left: 2vw;">
          {#each modification as review}
            <li class="sec2" style="position:relative; width:18vw;">
              {review.mark}
            </li>
          {/each}
        </ul>

        <button
          class="submit"
          style=" left: 3vw; top: 1vw;"
          on:click={() => {
            displayPopUp();
          }}
          >Submit Your Plan <img
            class="arrow"
            src="/images/home_page/arrow.svg"
            alt=""
          /></button
        >
      </div>
    </div>
  </div>
</div>
<div class="mobile">
  <MobileView />
</div>
<Footer />

<style>
  .top {
    position: absolute;
    left: 3vw;
    font-family: "Poppins";
    font-size: 1.563vw;
    font-weight: 500;

    text-align: left;
  }

  .para {
    position: absolute;
    top: 5vw;

    left: 48vw;
  }

  ul {
    position: relative;
    display: flex;
    list-style-type: square;
    top: 2w;
    flex-wrap: wrap;
  }

  .found {
    position: relative;
    font-family: "Poppins";
    font-size: 1.042vw;
    font-weight: 400;
    text-align: left;
  }
  li {
    position: relative;
    font-family: "Poppins";
    font-size: 1.042vw;
    width: 18vw;
    margin-right: 1vw;
    font-weight: 400;
    text-align: left;
    padding: 1vw;
  }

  .scale {
    position: relative;
    width: 3.854vw;
    left: -1.4vw;
    z-index: +5;
    top: 0.5vw;
  }

  .sec3 {
    position: relative;
    width: 16vw;
    margin-bottom: 0vw;
  }

  .sec5 {
    width: 16vw;
  }

  .sec4 {
    margin-bottom: 0.5vw;
    width: 16vw;
  }

  li::marker {
    position: relative;
    font-size: 1.3vw;
    color: #ff6d24;
    line-height: 0.2vw;
  }

  .arrow {
    width: 1.2vw;
  }

  .submit {
    position: relative;
    color: #ff6d24;
    font-family: "Inter" !important;
    font-size: 1.042vw;
    font-weight: 600;
    line-height: 1.25vw;
    text-align: left;
    left: 2vw;
  }
  .side {
    position: absolute;
    height: 26.042vw;
    width: 36.406vw;
    left: 6.385vw;
    top: 2.5vw;
    border-radius: 0.521vw;
  }
  .desktop {
    display: block;
  }
  .mobile {
    display: none;
  }
  @media screen and (max-width: 1024px) {
    .desktop {
      display: none;
    }

    .mobile {
      display: flex;
      justify-content: center;
    }
  }
</style>
